import Voucher from "../lib/voucher.js";
import "whatwg-fetch";

let $payment = null;
if (($payment = $("#payment")).length) {
  $payment.find(".payment-checkbox input").on("change", function () {
    if ($payment.find(".payment-checkbox input:checked").val() == "debit") {
      $payment.find(".extended").removeClass("hidden");
      $payment.find(".extended input").attr("required", true);
      $payment.find(".extended input").removeAttr("disabled");
    } else {
      $payment.find(".extended").addClass("hidden");
      $payment.find(".extended input").removeAttr("required");
      $payment.find(".extended input").attr("disabled", true);
    }
  });

  const $paymentMethodType1 = $("#account_payment_method_payment_type_1");
  if (window.location.hash == "#payment" && $paymentMethodType1.length) {
    $paymentMethodType1.trigger("click");
  }

  if ($("#register").length) {
    window.definePayment = function (total) {
      $payment.removeClass("hidden");
      if (total != 0) {
        if ($payment.find(".payment-checkbox input:checked").length == 0) {
          $payment.find(".payment-checkbox input").eq(1).trigger("click");
        }
      } else if (total == 0) {
        if ($payment.find(".payment-checkbox input:checked").length == 0) {
          $payment.find(".payment-checkbox input:first-child").trigger("click");
          $payment.addClass("hidden");
        } else if (
          $payment.find(".payment-checkbox input:checked").val() == "invoice"
        ) {
          $payment.addClass("hidden");
        }
      }
    };
  }
  $payment.find(".payment-checkbox input").trigger("change");
}

let $accountType = null;
if (($accountType = $("#account-type")).length) {
  const $form = $accountType.closest("form");
  const formName = $form.attr("name");

  $accountType.find("input").on("change", function () {
    const $companyFields = $form.find(".company");
    const $vatNumberField = $form.find(".vat-number");

    if ($accountType.find("input:checked").val() == "BUSINESS") {
      $companyFields.removeClass("hidden");
      $vatNumberField.show();
    } else {
      $companyFields.addClass("hidden");
      $vatNumberField.hide();
      $(`#${formName}_address_company`).val("");
      $(`#${formName}_vat_number`).val("");
    }
  });
  $accountType.find("input").trigger("change");

  var $poboxTrigger = null;
  if (($poboxTrigger = $("#usePOBox")).length) {
    var convertAddressToPO = function ($item) {
      var $poboxField = $(".pobox-field");
      if ($item.prop("checked") == true) {
        var prefix = $poboxField.attr("data-prefix");
        var label = $poboxField.attr("data-label-pobox");
        var value = $poboxField.find("input").val();
        value = value.replace(prefix, "");
        $(".no-pobox-field").find("input").removeAttr("required").val("");
        $(".no-pobox-field").addClass("hidden");
        $(".pobox-field").find("input").attr("required", "");
        $(".pobox-field")
          .find("input")
          .val(prefix + " " + value);
        $(".pobox-field")
          .find("input")
          .next("label")
          .addClass("mdc-floating-label--float-above")
          .text(label);
      } else {
        var label = $poboxField.attr("data-label-nopobox");
        $(".pobox-field").find("input").removeAttr("required").val("");
        $(".pobox-field")
          .find("input")
          .next("label")
          .removeClass("mdc-floating-label--float-above")
          .text(label);
        $(".no-pobox-field").find("input").attr("required", "");
        $(".no-pobox-field").removeClass("hidden");
      }
    };
    $poboxTrigger.on("change", function () {
      if (
        $(this).prop("checked") == true &&
        $("#useRentalAddress").length &&
        $("#useRentalAddress").prop("checked") == true
      ) {
        $("#useRentalAddress").prop("checked", false);
      }
      convertAddressToPO($(this));
      $("#useRentalAddress").trigger("change");
    });
    //on page load
    if ($poboxTrigger.prop("checked") == true) {
      var label = $(".pobox-field").attr("data-label-pobox");
      $(".no-pobox-field").find("input").removeAttr("required");
      $(".no-pobox-field").addClass("hidden");
      $(".pobox-field").find("input").attr("required", "");
      $(".pobox-field").find("input").next("label").text(label);
    }
  }

  if ($("#useRentalAddress").length && $("#address-edit").length) {
    var useRentalAddress = function (item) {
      let dataType = item.dataset.type;
      let value = item.value.trim();
      let $field = $(
        "#customer input[data-type=" +
          dataType +
          "], #customer select[data-type=" +
          dataType +
          "]"
      );
      $field.val(value);
      if (value == "") {
        $field.next("label").removeClass("mdc-floating-label--float-above");
      } else {
        $field.next("label").addClass("mdc-floating-label--float-above");
      }
      if ($("#usePOBox").length && $("#usePOBox").prop("checked")) {
        $(".no-pobox-field").find("input").val("");
        convertAddressToPO($("#usePOBox"));
      }
    };
    $("#useRentalAddress").on("change", function () {
      if ($(this).prop("checked") == true) {
        if ($("#usePOBox").length && $("#usePOBox").prop("checked") == true) {
          $("#usePOBox").prop("checked", false);
          convertAddressToPO($("#usePOBox"));
        }
        $(".copy-address").addClass("hidden");
        $("#address-edit .geocoder").each(function (idx, item) {
          useRentalAddress(item);
        });
      } else {
        $(".copy-address").removeClass("hidden");
      }
      $("#address-edit .geocoder").on("change", function () {
        if ($("#useRentalAddress").prop("checked") == true) {
          useRentalAddress(this);
        }
      });
    });
    if ($(".copy-address").hasClass("hidden")) {
      $("#useRentalAddress").prop("checked", true).trigger("change");
    }
  }
}

let $phone_number_list = null;

if (($phone_number_list = $("#phone-number-list")).length) {
  function preventEmptyPhoneList() {
    $phone_number_list.find(".number-input").on("change", function () {
      if ($(this).val() != "") {
        $(this).removeClass("clean");
      } else {
        $(this).addClass("clean");
      }
    });
  }
  var counter = $phone_number_list.find(".phone-number").length || 0;
  var max_numbers = $phone_number_list.data("widget-max") || 3;

  $phone_number_list.on("click", ".remove-collection-widget", function (e) {
    $(this).parents(".phone-number").eq(0).remove();
    counter--;
    if (counter < max_numbers) {
      $phone_number_list
        .nextAll(".add-collection-widget")
        .eq(0)
        .removeClass("hide");
      if (counter <= 0) {
        $phone_number_list.find(".default-phone-hint").removeClass("hide");
      }
    }
  });
  $phone_number_list
    .nextAll(".add-collection-widget")
    .eq(0)
    .on("click", function (e) {
      var list = $($(this).attr("data-list-selector"));

      counter =
        $phone_number_list.find(".phone-number").length ||
        list.data("widget-counter") ||
        0;
      if ($phone_number_list.find(".number-input.clean").length) {
        return false;
      }
      counter++;
      list.data("widget-counter", counter);
      if (counter > 0) {
        $phone_number_list.find(".default-phone-hint").addClass("hide");
        if (counter >= max_numbers) {
          $phone_number_list
            .nextAll(".add-collection-widget")
            .eq(0)
            .addClass("hide");
        }
      }

      var prototypeWidget = list.attr("data-prototype");
      var prefix = list.attr("data-prefix");
      var fieldName = list.attr("data-field-name") ?? "contacts";
      var customWidget = $(
        '<div class="custom-widget">' +
          '<div class="row g-0">' +
          '<div class="col-6 col-md-4">' +
          '<div class="mdc-text-field select-field">' +
          ' <span class="caret"></span>' +
          $(prototypeWidget)
            .find("#" + prefix + "_" + fieldName + "___name___number_country")
            .clone()
            .addClass("mdc-text-field__input transparent small")
            .wrap("<helper>")
            .parent()
            .html() +
          "</div>" +
          "</div>" +
          '<div class="col-12 col-md-4">' +
          '<div class="mdc-text-field text-field"> ' +
          $(prototypeWidget)
            .find("#" + prefix + "_" + fieldName + "___name___number_number")
            .clone()
            .addClass("mdc-text-field__input small number-input clean")
            .attr(
              "placeholder",
              window.Translator.trans(
                "form.fields.phone_numbers.label",
                {},
                "js"
              )
            )
            .attr(
              "oninvalid",
              "setCustomValidity('" +
                window.Translator.trans(
                  "form.fields.phone_numbers.validation.message",
                  {},
                  "js"
                ) +
                "')"
            )
            .attr(
              "pattern",
              window.Translator.trans(
                "form.fields.phone_numbers.validation.pattern",
                {},
                "js"
              )
            )
            .attr("oninput", "setCustomValidity('')")
            .attr(
              "aria-label",
              window.Translator.trans(
                "form.fields.phone_numbers.label",
                {},
                "js"
              )
            )
            .wrap("<helper>")
            .parent()
            .html() +
          "</div>" +
          "</div>" +
          '<div class="col-6 col-md-4 order-first order-md-last">' +
          '<div class="mdc-text-field select-field">' +
          '<span class="caret"></span>' +
          $(prototypeWidget)
            .find("#" + prefix + "_" + fieldName + "___name___type")
            .clone()
            .addClass("mdc-text-field__input transparent small")
            .wrap("<helper>")
            .parent()
            .html() +
          "</div>" +
          "</div>" +
          (counter > 1
            ? '<span class="remove-collection-widget" title="' +
              window.Translator.trans(
                "form.fields.phone_numbers.delete",
                {},
                "js"
              ) +
              '"><svg class="icon no" width="20" height="20"><use href="#no"></use></svg></span>'
            : "") +
          "</div>" +
          "</div>" +
          "</div>"
      ).html();

      customWidget = customWidget.replace(/__name__/g, counter);

      var newElem = $(list.attr("data-widget-tags")).html(customWidget);
      newElem.appendTo(list);
      preventEmptyPhoneList();
    });
  if ($phone_number_list.find(".phone-number").length == 0) {
    $phone_number_list.nextAll(".add-collection-widget").eq(0).trigger("click");
    preventEmptyPhoneList();
  }
}

if ($("#packages").length) {
  $("#packages input.package_checkbox").on("change", function () {
    var checked_package = $("#packages input.package_checkbox:checked").data(
      "package"
    ); // || $('#packages input.package_checkbox').data('package') || 'BRONZE';
    $("#summary .platform").addClass("hidden");
    $("#summary .voucher").addClass("hidden inactive");
    // if($(this).prop('checked') == true) {
    $("#summary .package-" + checked_package + ":not(.inactive)").removeClass(
      "hidden"
    );

    $("#summary").trigger("recalculate");
    if ($("#voucher input[type=text]").val != "") {
      $("#voucher button").trigger("click");
    }

    $("#summary .package-" + checked_package + ":not(.inactive)")
      .find(".abo-amount")
      .trigger("change");
  });

  if (
    $("#mapInsights").length &&
    typeof $("#mapInsights").data("package-recommendation") !== "undefined" &&
    (typeof $("#packages").data("preselected") === "undefined" ||
      $("#packages").data("preselected") == 0)
  ) {
    setTimeout(function () {
      $(
        "#packages input[name=package][value=" +
          $("#mapInsights").data("package-recommendation") +
          "]"
      ).trigger("click");
    }, 500);
  }
}

if ($("#voucher").length) {
  var voucher = new Voucher();
  $("#voucher input[type=text]").on("keydown", function (event) {
    $("#voucher .loader, #voucher .circle_check").hide();
    $("#voucher button").show();
    var keycode = event.keyCode ? event.keyCode : event.which;
    if (keycode == "13") {
      $("#voucher button").trigger("click");
      return false;
    }
  });

  $("#voucher button").on("click", function (e) {
    e.preventDefault();
    let checked_package =
      $("#packages input.package_checkbox:checked").data("package") ||
      $("#locations-top-entry").data("package") ||
      0;
    let value = $("#voucher").find("input[type=text]").val();

    voucher.redeem(value, checked_package, "voucher");
  });

  if ($("#voucher input[type=text]").val() != "") {
    $("#voucher button").trigger("click");
    if ($(".toggler").length) {
      $(".toggler").trigger("click");
    }
  }
}

var $company_field;
if (
  ($company_field = $(".company-field")).length &&
  $(".private-field").length
) {
  $company_field
    .on("change", function () {
      if ($(this).val() == "") {
        $(".private-field").attr("required", true);
      } else {
        $(".private-field").removeAttr("required");
      }
    })
    .trigger("change");
}

if ($("#locations-top-entry").length == 0) {
  const PERMANENT_DISCOUNT =
    100 - ($("#summary").data("permanent-discount") || 0);

  $("#summary").on("recalculate", function () {
    var VAT_PERCENTAGE = $("#summary").data("vat-percentage");
    if (
      $("#country").length &&
      $("#vat_number").length &&
      $("#country").find("option:selected").val() != "DE" &&
      $("#vat_number").find("input[type=text]").val() != ""
    ) {
      VAT_PERCENTAGE = 0;
    }
    var net = 0;
    var percentDiscount = 0;
    var balance = 0;
    $("#summary tr.calculate:not(.hidden):not(.inactive)[data-amount]").each(
      function (idx, row) {
        var rowAbo =
          typeof $(row).attr("data-abo") !== "undefined" &&
          (typeof $(row).attr("data-avoid-abo-calc") === "undefined" ||
            !$(row).attr("data-avoid-abo-calc"))
            ? $(row).attr("data-abo")
            : 1;
        if ($(row).hasClass("voucher")) {
          // if ($(row).attr('data-type') == 'ABSOLUTE_VALUE') {
          //     net = $(row).data('amount');
          //     return false;
          // }
          if ($(row).attr("data-type") == "VALUE") {
            net -= $(row).attr("data-amount");
          } else if ($(row).attr("data-type") == "PERCENTAGE") {
            percentDiscount = $(row).attr("data-amount");
          }
        } else if ($(row).hasClass("balance")) {
          balance = $(row).attr("data-amount") * 1.0;
        } else {
          net += $(row).attr("data-amount") * rowAbo;
        }
      }
    );

    if (percentDiscount != 0) {
      var percentDiscountValue = -((net * percentDiscount) / 100);
      $("#summary .voucher:not(.hidden) td.amount").text(
        amountToHuman(percentDiscountValue * 1.0)
      );
      net += percentDiscountValue;
    }
    net = net + balance;
    var vat = VAT_PERCENTAGE * net;
    var total = vat + net;
    var permanent_discount_amount = total - total * (PERMANENT_DISCOUNT / 100);
    var netHuman = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(net);
    var vatHuman = amountToHuman(vat);
    var totalHuman = amountToHuman(total - permanent_discount_amount);
    var permanentDiscountHuman = amountToHuman(-permanent_discount_amount);
    $("#summary .net").attr("data-amount", net);
    $("#summary .net .amount").text(netHuman);
    $("#summary .vat").attr("data-amount", vat);
    $("#summary .vat .rate").text(VAT_PERCENTAGE * 100);
    $("#summary .vat .amount").text(vatHuman);

    if (PERMANENT_DISCOUNT > 0) {
      $("#summary .permanent-discount").attr("data-amount", vat);
      $("#summary .permanent-discount .amount").text(permanentDiscountHuman);
    }
    $("#summary .final").attr("data-amount", total);
    $("#summary .final .rate").text(VAT_PERCENTAGE * 100);
    $("#summary .final .amount").text(totalHuman);
    if (
      VAT_PERCENTAGE == 0 &&
      $("#country").length &&
      $("#vat_number").length
    ) {
      $("#summary .vat .label").html($("#summary .vat").data("label-reversed"));
      $("#summary .final .label").html(
        $("#summary .final").data("label-reversed")
      );
    } else if ($("#country").length && $("#vat_number").length) {
      $("#summary .vat .label").html($("#summary .vat").data("label-vat"));
      $("#summary .final .label").html($("#summary .final").data("label-vat"));
    }

    if (total == 0) {
      $(".submitter input").val($("#summary").data("label-free"));
      $("button.submitter").text($("#summary").data("label-free"));
    } else {
      $(".submitter input").val($("#summary").data("label-costs"));
      $("button.submitter").text($("#summary").data("label-costs"));
    }

    if (typeof window.definePayment !== "undefined") {
      window.definePayment(total);
    }
  });

  $("#country select, #vat_number input").on("change", function () {
    window
      .fetch("/document/tax-rate/" + $("#country").find("select").val())
      .then((res) => res.json())
      .then(
        (result) => {
          $("#summary").data("vat-percentage", result);
          $("#summary").trigger("recalculate");
          $(".static-vat").addClass("hide");
          $(".add-non-vat").removeClass("hide");
          $(".non-vat").removeClass("light small gray");
          $(".non-vat").addClass("big");
        },
        (error) => {
          $("#summary").trigger("recalculate");
        }
      );
  });

  $(".abo-amount").on("change", function () {
    let $parent_tr = $(this).parents("tr").eq(0);
    let parent_type = $parent_tr.attr("class").replace(/^(\S*).*/, "$1");
    console.log($("." + parent_type + "_abo").attr("name"));
    let abo_period =
      $(this).find("option:selected").val() || $(this).data("abo") || 12;
    let abo_price =
      $(this).find("option:selected").data("price") ||
      $(this).data("price") ||
      0;
    //$('.'+parent_type+'[data-abo]').attr('data-abo',abo_period);
    //$('.'+parent_type).find('option[value='+abo_period+']').attr('selected','selected');
    //$('.'+parent_type).find('option[value='+abo_period+']').siblings().removeAttr('selected');
    $("." + parent_type)
      .find(".abo-amount")
      .removeAttr("name");
    $parent_tr.attr("data-abo", abo_period);
    $parent_tr
      .find(".abo-amount")
      .attr("name", $("." + parent_type + "_abo").attr("name"));
    $parent_tr.attr("data-amount", abo_price);
    $parent_tr
      .find(".total-abo")
      .text(amountToHuman(abo_period * abo_price * 1.0));

    $("#summary").trigger("recalculate");
  });
  $("#summary").trigger("recalculate");
}

if ($("#vat_number").length) {
  let changeHint = function () {
    var currentCountry =
      $("select[data-type=country]").last().val() || $("#country").val();
    if (currentCountry == "DE" || (region == "DE" && currentCountry == "")) {
      $(".hint .hint-de").removeClass("hidden");
      $(".hint .hint-global").addClass("hidden");
    } else {
      $(".hint .hint-global").removeClass("hidden");
      $(".hint .hint-de").addClass("hidden");
    }
  };
  $("#register_rental_address_country, #rental_address_country, #country").on(
    "change",
    function () {
      changeHint();
    }
  );
  changeHint();
}

if ($("#account-payment-methods").length) {
  $(".add-collection-widget").on("click", addPrototypeToCollection);
  $(".remove-collection-widget").on("click", removeFormFromCollection);

  toggleCashPaymentAdder();
  toggleOverwritePaymentMethods();

  function addPrototypeToCollection() {
    let prototype = $(this).closest("[data-prototype]").data("prototype");
    let collectionHolder = $(this).parents().find(".collection-holder");
    let newElement = $("<li></li>")
      .addClass("input-element")
      .html(prototype.replace(/__name__/g, collectionHolder.data("index")));

    collectionHolder.append(newElement);
    collectionHolder.data("index", collectionHolder.data("index") + 1);

    window.initFloatingLabels(); // init mdc on new elements

    $(".remove-collection-widget").on("click", removeFormFromCollection);

    toggleCashPaymentAdder();
    toggleOverwritePaymentMethods();
    toggleDropDown();
    closeDropDown();
  }

  function removeFormFromCollection() {
    $(this).closest(".input-element").remove();

    toggleCashPaymentAdder();
    toggleOverwritePaymentMethods();
    toggleDropDown();
    closeDropDown();
  }

  function toggleCashPaymentAdder() {
    if ($(".cash_payment").length !== 0) {
      $("#cash-payment-adder").hide();
    } else {
      $("#cash-payment-adder").show();
    }
  }

  function closeDropDown() {
    $("#paymentTypeDropdown").removeClass("open");
  }

  function toggleDropDown() {
    const maxLength = $(".collection-holder").data("max");
    if ($(".input-element").length > maxLength) {
      $("#paymentTypeDropdown").hide();
    } else {
      $("#paymentTypeDropdown").show();
    }
  }

  function toggleOverwritePaymentMethods() {
    if ($(".collection-holder").children().length != 0) {
      $("#overwrite-payment-methods").addClass("d-flex").show();
    } else {
      $("#overwrite-payment-methods").removeClass("d-flex").hide();
    }
  }
}

if ($("#rental-payment-methods").length) {
  $('.checkbox-panel input[type="checkbox"]').each(function () {
    $(this).on("click", function () {
      let checkboxPanel = $(this).closest(".checkbox-panel");

      if ($(this).is(":checked")) {
        checkboxPanel.addClass("active");
        checkboxPanel.removeClass("opacity-75");
      } else {
        checkboxPanel.removeClass("active");
        checkboxPanel.addClass("opacity-75");
      }
    });
  });
}
